import { Grid } from '@mui/material';
import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import SingleRecording from './SingleRecording';
import { chatSlimScrollbarStyles } from '../../utils/styles';
import { useAppSelector } from '../../redux/hooks';
import NoRecordings from './NoRecordings';
import LoadingRecordings from './LoadingRecordings';

interface IRecordingProps {
  isCurrentlyRecording?: boolean;
}
function Recordings({ isCurrentlyRecording }: IRecordingProps) {
  const { noteRecordings, getNoteRecordingsLoading } = useAppSelector((state) => state.note);
  const [selectedRecordingIndices, setSelectedRecordingIndices] = useState<number[]>([]);

  const handleSelect = (index: number) => {
    setSelectedRecordingIndices((prevIndices) => {
      if (prevIndices.includes(index)) {
        return prevIndices.filter((i) => i !== index);
      }
      return [...prevIndices, index];
    });
  };

  if (getNoteRecordingsLoading) {
    return (
      <Grid>
        {Array.from({ length: 7 }).map((_) => (
          <LoadingRecordings key={uuidv4()} />
        ))}
      </Grid>
    );
  }

  if (noteRecordings.length === 0) {
    return (
      <Grid display="flex" height={isCurrentlyRecording ? '60%' : '75%'} alignItems="center">
        <NoRecordings />
      </Grid>
    );
  }

  return (
    <Grid
      overflow="scroll"
      height={isCurrentlyRecording ? '60%' : '75%'}
      sx={{
        ...chatSlimScrollbarStyles,
        overflowX: 'hidden',
      }}
    >
      {noteRecordings?.map((recording, index) => (
        <SingleRecording
          index={index}
          key={recording.id}
          isSelected={selectedRecordingIndices.includes(index)}
          onSelect={() => handleSelect(index)}
          recording={recording}
        />
      ))}
    </Grid>
  );
}

export default Recordings;
